

























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as utils from '@/utils';
import * as utils_tracker from '@/utils_tracker';
import AlertDealsListComponent from '@/components/AlertDealsListComponent.vue';                       // @ is an alias to /src
import { TokenUser } from '@/TokenUser'
import { Alert } from '@/Alert'
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src
import * as utils_auth from '@/utils_auth';
import { globalUC } from '../UserCache';

@Component({
  name: 'AlertDeals',
  components: { AlertDealsListComponent, ModalWrapperComponent }
})

export default class AlertDealsComponent extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public lastFetchedURL: string = null;
  public alerts: Alert[] = []

  // UI and filter options

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }

  public userChoseRegister(): void {
    utils_auth.setLocationAfterLogin({ name: "home" });
    (this.$refs.RegisterFormModalComponent as ModalWrapperComponent).show('LiveToken Registration', 'sm', null)
  }
  public useChoseEnableTelegramAlerts(): void {
    (this.$refs.EnableTelegramAlertsComponent as ModalWrapperComponent).show('Enable Telegram Alerts', 'md', null)
  }

  public onClickedCreate(): void {
    if (!this.user.emailVerified && !this.user.telegramConfirmed) {
      utils.toast(this, 'Error', `Please verify your email address or Telegram account first.`)
      return
    }

    let LIMIT: number = 60
    if (this.userId === '6087169a543384effd32a91b') LIMIT = 60    // hack for more for Libruary
    if (this.alerts.length >= LIMIT) {
      utils.toast(this, 'Alert Limit', `For now, the limit is ${LIMIT} alerts.`)
      return
    }
    (this.$refs.AlertFormComponent as ModalWrapperComponent).show('Create a New Alert', 'md', null)
  }

  public onClickedEdit(alert: Alert): void {
    (this.$refs.AlertFormComponent as ModalWrapperComponent).show('Edit an Alert', 'md', alert)
  }

  public async onFormClosed(componentName: string, showing: boolean, payload: any) {
    if (showing) return
    if (payload) {
      // existence of payload means the user edited or create an alert, so let's be lazy and refetch the full list
      const alert: Alert = payload
      await this.fetchData()
    }
  }

  public async resendEmail(): Promise<void> {
    try {
      this.$store.commit('setLoading', { loading: true });
      const url: string = utils.getURLprefix() + `/api/auth/resendEmailConfirmationCode`;
      const response: any = await utils.makeGetCall(url);
      if (!response || !response.data) throw(new Error('AlertDealsComponent.resendEmail() got null response or null response.data'))

      // something is wrong with the alert
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
        this.$store.commit('setLoading', { loading: false });
        return
      }
      
      // might as well update the user
      if (response.data.user) {
        const user: TokenUser = new TokenUser(response.data.user)
        user.email = response.data.email     // this got stripped away to make safe for client
        utils_auth.saveAuthStuffToStoreAndLocalStorage(user, response.data.sessionId)
        globalUC.add(user)      // might as well give cache the very latest one

        if (!response.data.verified) utils.toast(this, 'Email Sent', `Please click on the email confirmation sent to ${user.email}.`);
        else utils.toast(this, 'Already Verified', `Your email address, ${user.email}, is already verified.`);

      }

    } catch (error) {
      utils.toast(this, 'System Error', 'Could not sende email confirmation')
      if (this.$store.state.devmode) console.error(error);
    } finally {
      this.$store.commit('setLoading', { loading: false });
    }
  }

  public async onClickedDelete(alert: Alert): Promise<void> {
    // make DELETE call to server
    try {
      this.$store.commit('setLoading', { loading: true });
      const url: string = utils.getURLprefix() + `/api/topshot/alert/${alert.getIdAsString()}`;
      const response: any = await utils.makeDeleteCall(url);
      if (!response || !response.data) throw(new Error('AlertFormComponent.onOK() got null response or null response.data'))

      // something is wrong with the alert
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
      }
      
      // might as well update the user
      if (response.data.user) {
        const user: TokenUser = new TokenUser(response.data.user)
        user.email = response.data.email     // this got stripped away to make safe for client
        utils_auth.saveAuthStuffToStoreAndLocalStorage(user, response.data.sessionId)
        globalUC.add(user)      // might as well give cache the very latest one
      }

    } catch (error) {
      utils.toast(this, 'System Error', 'Could not delete alert')
      if (this.$store.state.devmode) console.error(error);
    } finally {
      this.$store.commit('setLoading', { loading: false });
    }

    // so let's refetch all the alerts now that it's deleted
    await this.fetchData()

  }

  // private, non-reactive member variables
  private lastFetchSucceeded: boolean;

  private async pathChanged(): Promise<void> {
    if (this.$store.state.devmode) console.log(`AlertDealsComponent.pathChanged() ${this.$route.path}`)
  }

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`);

    utils_tracker.page(this.$options.name)

    if (this.user) await this.fetchData()

  }

  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`)
  }

  private async fetchData(): Promise<number> {
    const url: string = utils.getURLprefix() + `/api/topshot/alerts`;

    // don't fetch if we're in the middle of fetching same url
    if (this.loading) {
      if (this.lastFetchedURL === url) {
        if (this.$store.state.devmode) console.log(`AlertDealsComponent.fetchData() aborting calledByInfiniteHandler and we're already loading`)
        await utils.sleep(1000)     // wait 1 s so we don't go into 100% CPU infinite loop
        return
      }
    }

    this.$store.commit('setLoading', { loading: true });
    this.lastFetchedURL = url;

    try {
      // console.log(url)
      this.lastFetchSucceeded = false;
      const response: any = await utils.makeGetCall(url);

      // whoa, we got another call after this one, so let's abort this one cuz the latest one should take precedent
      if (this.lastFetchedURL !== url) return

      // in case old version
      if (utils.isClientOld()) {
        if (this.$store.state.devmode) console.log("Calling this.$router.go(0)");
        this.$router.go(0);
        this.$store.commit('setLoading', { loading: false });
        return;
      }

      // error check
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
        this.$store.commit('setLoading', { loading: false });
        return
      }

      // might as well update the user
      if (response.data.user) {
        const user: TokenUser = new TokenUser(response.data.user)
        user.email = response.data.email     // this got stripped away to make safe for client
        utils_auth.saveAuthStuffToStoreAndLocalStorage(user, response.data.sessionId)
        globalUC.add(user)      // might as well give cache the very latest one
      }
      
      // load up the moments separately from the FastFingerList object in case we want to do paging (might do everything inside FastFingerList eventually)
      let newRawItems: Alert[] = response.data.alerts
      if (newRawItems) {
        newRawItems = newRawItems.map((po) => new Alert(po));
        if (newRawItems.length > 0) this.alerts = newRawItems; else this.alerts = []
        this.lastFetchSucceeded = true
        return newRawItems.length
      } else {
        this.lastFetchSucceeded = false;
        return 0
      }

    } catch (error) {
      if (error.toString().includes('Network Error') || error.toString().includes('status code 502')) utils.toast(this, 'Error', 'Undergoing Maintenance'); else utils.toast(this, 'Error', 'Could not load url')
      if (this.$store.state.devmode) console.log(error);
      return 0
    } finally {
      this.$store.commit("setLoading", { loading: false });
    }

    this.$store.commit("setLoading", { loading: false });
  }  
}
